import { createContext, useContext, useMemo, useState } from "react";
import {useAuthContext} from "./auth";
import {ROLE_APPRENTICE_ID} from "../util/roles";
import {useForumsTopicsListRequest} from "../request/api";

const TopicListContext = createContext();

/**
 * Approach inspired by {@link https://blog.logrocket.com/guide-state-management-next-js/}
 */
export function TopicListProvider({ children, forumId = undefined, query = undefined, tag = undefined }) {
  const { auth } = useAuthContext();
  const defaultSort = auth?.user?.role === ROLE_APPRENTICE_ID ? "recent" : "popular";

  const [sortBy, setSortBy] = useState();

  const topicsRequest = useForumsTopicsListRequest(
    {
      forumId,
      query: query,
      sort: sortBy ?? defaultSort,
      tag: tag,
    },
    {
      shouldFetch: !!forumId,
    }, {
      withCredentials: true,
    }
  );


  const value = useMemo(
    () => ({
      topics: topicsRequest.data,
      isLoadingTopics: topicsRequest.isLoading || !forumId,
      reloadTopics: topicsRequest.mutate,
      topicError: topicsRequest.error,
      sortBy: sortBy ?? defaultSort,
      setSortBy,
    }),
    [topicsRequest, sortBy, setSortBy]
  );

  return (
    <TopicListContext.Provider value={value}>{children}</TopicListContext.Provider>
  );
}

export function useTopicListContext() {
  return useContext(TopicListContext);
}
